const INITIAL_STATE = {list: []}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'NOTIFICACAO_USUARIO_FETCHED':
            return { ...state, list: action.payload.data }
        case 'NOTIFICACAO_USUARIO_CLEAR':
            return { ...state, list: [] }
        default:
            return state
    }
}
